import React, { useEffect } from 'react';
import useAuthStore from '../../store/authStore';

const AuthChecker = ({ children }) => {
  const { isAuthenticated, token } = useAuthStore();

  // Función para verificar si un JWT está expirado
  const isTokenExpired = (token) => {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      // Si no puede parsear el token, considerarlo expirado
      return true;
    }
  };

  useEffect(() => {
    // No verificar si ya estamos en la página de login
    if (window.location.pathname === '/login') {
      return;
    }

    // Verificar si existe auth-storage en localStorage
    const authStorage = localStorage.getItem('auth-storage');

    if (!authStorage) {
      // No hay auth-storage, redirigir a login
      console.log('No se encontró auth-storage en localStorage, redirigiendo a login');
      window.location.href = '/login';
      return;
    }

    try {
      const parsedAuth = JSON.parse(authStorage);
      const storedToken = parsedAuth?.state?.token;

      if (!storedToken) {
        // No hay token en el storage, redirigir a login
        console.log('No se encontró token en auth-storage, redirigiendo a login');
        window.location.href = '/login';
        return;
      }

      // Verificar si el token está expirado
      if (isTokenExpired(storedToken)) {
        console.log('Token expirado, limpiando storage y redirigiendo a login');
        localStorage.removeItem('auth-storage');
        useAuthStore.getState().logout();
        window.location.href = '/login';
        return;
      }

      // Si hay token válido pero no está autenticado en el store, podría ser token expirado
      // El interceptor de axios ya maneja esto, pero podemos hacer una verificación adicional
      if (!isAuthenticated && storedToken) {
        console.log('Token encontrado pero no autenticado, verificando validez...');
        // Aquí podríamos hacer una llamada de verificación al backend si es necesario
      }

    } catch (error) {
      console.error('Error al parsear auth-storage:', error);
      // Si hay error al parsear, limpiar y redirigir
      localStorage.removeItem('auth-storage');
      window.location.href = '/login';
    }
  }, [isAuthenticated]); // Removí navigate de las dependencias

  return children;
};

export default AuthChecker;